export const DeliverrWebsite = "https://deliverr.com";

export const ResourceWebsite = "https://resources.deliverr.com";

export const SupportWebsite = "https://support.deliverr.com";

export const MailToFreight = "mailto:freight@deliverr.com";

export const linkToWebsite = (base: string, path: string) => base + path;
